export const theme = {
  primary: '#41b9b9',
  primaryStrong: '#2a8a8a',
  notificationAccent: '#41b9b9',
} as const;
